import cn from 'clsx';
import { ReactNode } from 'react';

import Title from './Title';
import Item from './Item';

type Props = {
  flush?: boolean;
  className?: string;
  children: ReactNode;
};

function MenuPanel({ flush, className, children }: Props) {
  return (
    <div className={cn('border-b-[1.5px] border-slate-200', { 'py-5 px-4': !flush, 'px-0 py-0': flush }, className)}>
      {children}
    </div>
  );
}

export default Object.assign(MenuPanel, { Title, Item });
